import { UseMutationOptions, useMutation } from 'react-query';
import { signIn } from 'supertokens-web-js/recipe/emailpassword';

import { trackEvent } from 'src/Services/Matomo';
import { trackUserLoggedIn } from 'src/Services/Mixpanel/events';

export class SignInError extends Error {
  constructor(private formFields: { id: string; error: string }[]) {
    super(JSON.stringify(formFields));
    Object.setPrototypeOf(this, SignInError.prototype);
  }

  getDetails() {
    return this.formFields;
  }
}

export const useSignIn = (
  options?: UseMutationOptions<
    void,
    unknown,
    {
      email: string;
      password: string;
    },
    unknown
  >
) => {
  return useMutation({
    ...options,
    mutationKey: ['sign-in'],
    mutationFn: async ({ email, password }: { email: string; password: string }) => {
      const response = await signIn({
        formFields: [
          {
            id: 'email',
            value: email,
          },
          {
            id: 'password',
            value: password,
          },
        ],
      });

      if (response.status === 'FIELD_ERROR') {
        throw new SignInError(response.formFields);
      } else if (response.status === 'WRONG_CREDENTIALS_ERROR') {
        throw new SignInError([
          {
            id: 'password',
            error: 'Email password combination is incorrect.',
          },
        ]);
      } else if (response.status === 'SIGN_IN_NOT_ALLOWED') {
        throw new SignInError([
          {
            id: 'password',
            error: 'Password combination is incorrect, please reset it.',
          },
        ]);
      }
    },
    onSuccess: (data, variables, context) => {
      trackEvent('Auth', 'signin', variables.email);
      trackUserLoggedIn({ method: 'email_password' });
      options?.onSuccess?.(data, variables, context);
    },
  });
};
